import React, { useContext, FormEvent } from 'react';
import { Confirmation, RouterContext } from '../../gs-component-right-rail';

interface UtilFuncs {
  resetForm: any;
}
interface Props {
  onClose: () => void;
  onSubmit: (e: FormEvent<HTMLFormElement>) => void;
  setShouldClose: (shouldClose: boolean) => void;
}

const CancelConfirmation: React.FC<Props> = ({ onClose, onSubmit, setShouldClose }) => {
  const { goBack } = useContext(RouterContext);
  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    setShouldClose(true);
    onSubmit(e);
  };

  return (
    <Confirmation
      question="Looks like you just made some edits to that guest. Want to save them before you go?"
      primaryText="Yes, Please!"
      secondaryText="No, Thanks"
      tertiaryText="Keep editing"
      onPrimaryAction={handleSubmit}
      onSecondaryAction={onClose}
      onTertiaryAction={goBack}
    />
  );
};

export default CancelConfirmation;
